export default __webpack_public_path__ + "static/media/CHAT2.7c432148.jpg";